import {EltrpPage} from "../layout/wrappers/eltrp-page";
import {EltrpHeader} from "../layout/wrappers/eltrp-header";
import {EltrpBody} from "../layout/wrappers/eltrp-body";
import {EltrpText} from "../layout/wrappers/eltrp-text";
import {NewsletterForm} from "../features/newsletter/components/newsletter-form";
import {useEffect} from "react";

export const NewsletterPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <EltrpPage metaTitle={"ELTRP Newsletter"} metaDescription={"Subscribe for updates about updates to the platform and new publications."}>
            <EltrpHeader title={"Get the latest insights"}/>
            <EltrpBody>
                <EltrpText>
                    <h2> Subscribe for updates!</h2>
                    <p>
                        Get notified when new publications and projects are added to ELTRP. Fill in the form below for updates directly to your inbox.
                        You will receive a confirmation email at the address provided. If you don’t receive
                        a confirmation, please check your spam folder or contact <a
                        href="mailto:info@eltrp.org">info@eltrp.org</a>
                    </p>
                    <h3> Archive </h3>
                    <p>
                        Subscribers also receive updates on new functionalities and achievements in ELTRP. All previous newsletters of this kind can be found in the <a
                        href={
                            "https://ui.ungpd.com/Issues/Archive/Categories/fd85cc73-fae2-4d0d-997f-3f9557d5586a"
                        }
                        target={"_blank"}
                        rel={"noreferrer"}
                    >
                        archive
                    </a>{""}. Visit it to review older updates, and don’t forget to subscribe for upcoming ones.{" "}
                    </p>
                </EltrpText>
                <EltrpText>
                    <NewsletterForm/>
                </EltrpText>
            </EltrpBody>
        </EltrpPage>
    );
};
